module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACsAAAAxCAYAAABDEFA9AAABSElEQVRoQ+2Z0Q2CMBCG7wJDqK+4jK5h4gJGnUGMI7CGLiOPCkOANWhIxEKvFGlRj+e2/Hzc/x+0CI6u7LyaIfoRgBjTEjARIlsgPbCfEXm8veoJLe+PiUOxG9EWA4vVIZbHTFaHU/sxTLY9M70ZVsk2h/ozwP3p4aSSbVWsOtQx8YLdZEBi1dHjBaEywy2TZbFKdxq3W+o1chnopaI8iskS5LAa7nqBXqzphKwc7nSgOxQr5yXlZBar4XSsqz0m+0aOMmgdaCZbUKFKick2mZQiw2S/LLqkDbLUC0JyZ89JGWTxeo6AEQCMAPAi4Lb0g/2RaihOxFKiBmUwFttXU2CyTBbgX/YNlKctZGOhcrr2e9bUYNVm8rqKXmOxKtb0Ict5LLYrQdN2/dGa7foQXAZdCf5IGbQ9FYfUuIN1Jd6c07XWevwU3AGRS4K+5fCREQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/SPSR/icon_0@2x.png
// module id = xLrf
// module chunks = 70